import * as z from "zod";

export const validationSchema = z.object({
  companyId: z.number().int().nonnegative(),
  companyName: z.string().min(1, { message: "validation:companyNameRequired" }),
  vatno: z.string().min(1, { message: "validation:vatNumberRequired" }),
});

export const CompanyPrivateNetworkValidationSchema = validationSchema;
export type CompanyPrivateNetworkFormInput = z.infer<typeof CompanyPrivateNetworkValidationSchema>;
